import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const GraderNotesSection = ({ comments }) => {
  const COMMENT_TYPE = {
    CORRECT_ANSWER: 'correct_answer',
    NOTE_GRADER: 'note_to_grader',
  };

  return comments
    ?.sort((a, b) => a.commentType.localeCompare(b.commentType))
    .map(c => {
      if (!c.comment || !c.active) {
        return null;
      }
      let commentTitle = '';
      switch (c.commentType) {
        case COMMENT_TYPE.CORRECT_ANSWER:
          commentTitle = t('grades.correct_answer');
          break;
        case COMMENT_TYPE.NOTE_GRADER:
          commentTitle = t('grades.notes_for_grading');
          break;
        default:
          commentTitle = '';
      }
      return (
        <div key={commentTitle} className="d-f fd-c mb-16 ws-pl">
          <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
            <div className="mb-4">{commentTitle}</div>
          </Text>
          <Text variant={TEXT_VARIANTS.BODY}>
            <span className="fz-14 wb-bw">{c.comment}</span>
          </Text>
        </div>
      );
    });
};

export default GraderNotesSection;
